import { constants } from './constants';

export const determineMimeType = (mimeType: string) => {
  return mimeType.split('/')[0];
};

export const sizeLimitByType: { [key: string]: number } = {
  image: constants.MAX_IMAGE_FILE_SIZE_IN_MB,
  video: constants.MAX_VIDEO_FILE_SIZE_IN_MB,
  document: constants.MAX_PDF_FILE_SIZE_IN_MB,
  audio: constants.MAX_AUDIO_FILE_SIZE_IN_MB,
};
